export const getCurrentUser = () => window.GLOBAL_INFO.rtx;
